import React from 'react'
import { useViewport } from '../../utils'
import { useSelector } from 'react-redux'
import auth from '../../utils/auth'
import DesktopLayout from './desktop-layout'
import MobileLayout from './mobile-layout'
import { ROLE_ADAPTER } from '../../constants'
const { getAccountTypeId } = auth()

const DashboardLayout = ({children, ...props}) => {
  const { isDesktop } = useViewport()
  const account = useSelector(state => state.account.data)
  const type = getAccountTypeId(account)
  const role = Object.keys(ROLE_ADAPTER).filter(key => ROLE_ADAPTER[key] === type)[0]

  return isDesktop ? (
    <DesktopLayout role={role}>
      {children}
    </DesktopLayout>
  ) : (
    <MobileLayout role={role} {...props}>
      {children}
    </MobileLayout>
  )
}

export { DashboardLayout }
